import { createSlice } from "@reduxjs/toolkit";

export interface emailState {
  data: [] | null | any;
  totalRecords: number | null;
  totalPage: number | null;
}

const initialState: emailState = {
  data: null,
  totalRecords: null,
  totalPage: null,
};

export const emailSlice = createSlice({
  name: "email",
  initialState,
  reducers: {
    setEmail: (state, action) => {
      state.data = action.payload && action.payload.data;
      state.totalRecords = action.payload && action.payload.totalRecords;
      state.totalPage = action.payload && action.payload.totalPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setEmail, reset } = emailSlice.actions;

export const getEmailData = (state: any) => state.email.data;
export const getEmailTotalRecord = (state: any) => state.email.totalRecords;
export const getEmailTotalPages = (state: any) => state.email.totalPage;

export default emailSlice.reducer;
